import { Box, Typography } from '@mui/material'
import { useTheme } from '../../contexts/ThemeContext'
import { createSectionTitleStyles } from './commonStyles'
import type { ReactNode } from 'react'

interface SectionHeaderProps {
  title: string
  action?: ReactNode
}

export default function SectionHeader({ title, action }: SectionHeaderProps) {
  const { colors } = useTheme()

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 2,
      }}
    >
      <Typography variant="h5" sx={createSectionTitleStyles(colors)}>
        {title}
      </Typography>
      {action && <Box>{action}</Box>}
    </Box>
  )
}
